import React, { useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AddCustom from './addCustom'
import { getMetaData, updateMetaData } from '../../../../Redux/Actions/metaDataAction'
import { isEmpty, checkPermissions } from 'src/views/utils/helper'
import SearchTable from 'src/components/searchTable'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { GlobalContext } from '../../../context/GlobalState'
import { PERMISSIONS } from '../../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from 'src/views/context/app'
import { useLocation } from 'react-router-dom'

const CustomMetaDataListing = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const isMarketing = location.pathname.includes('marketing-fields')

  const [customMetadata, setcustomMetadata] = useState([])
  const [showAdd, setShowAdd] = useState(false)
  const language = localStorage.getItem('language')
  const [editInfo, setEditInfo] = useState({})
  const { refreshData } = useSelector((state) => state.commonReducer)
  const { accountObj } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.META_DATA.CREATE) &&
    defaultLangCheck
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.META_DATA.UPDATE,
  )

  useEffect(() => {
    getCustomMetadata()
  }, [refreshData])

  const getCustomMetadata = async () => {
    const res = await dispatch(getMetaData('custom'))
    if (res?.success && !isEmpty(res?.data)) {
      const { data } = res
      let tempCustom = []
      data.forEach((element) => {
        let tempObj = element
        element.type === 'radio'
          ? (tempObj['view'] = `Multiple Choice`)
          : element.type === 'text'
          ? (tempObj['view'] = `Text Field`)
          : (tempObj['view'] = `${element.type}`)

        tempCustom.push(tempObj)
      })

      let finalArr = isMarketing
        ? tempCustom.filter((info) =>
            ['campaign', 'campaign-audience', 'email-template'].includes(info.entity_type),
          )
        : tempCustom.filter((info) => ['content', 'artist', 'venue'].includes(info.entity_type))
      setcustomMetadata(finalArr)
    }
  }

  const handleStatus = async (info) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    let res = await dispatch(updateMetaData('custom', info._id, { status: !info.status }))

    if (res?.success) {
      dispatch({ type: 'REFRESH_DATA' })
    } else {
      console.log('failed')
    }
  }
  const handleEdit = (info) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setEditInfo(info)
    setShowAdd(true)
  }

  const tableConfig = [
    {
      header: 'Metadata Field',
      dataCell: (info) => info.name,
      width: 25,
    },
    {
      header: 'View',
      dataCell: (info) => info.view,
      width: 23,
    },
    {
      header: 'Type',
      dataCell: (info) => info.entity_type,
      width: 20,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 20,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 7,
    },
  ]
  const handleAdd = () => {
    if (!createAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))

    setShowAdd(true)
  }
  return (
    <div>
      <h4>{isMarketing ? 'Custom Properties' : 'Custom Metadata'} </h4>
      <p>Define your own {isMarketing ? 'Marketing' : ''} Metadata fields.</p>
      {showAdd ? (
        <AddCustom
          isMarketing={isMarketing}
          setShowAdd={setShowAdd}
          editInfo={editInfo}
          setEditInfo={setEditInfo}
        />
      ) : (
        <SearchTable
          type={`Custom Metadata`}
          tableCardHeight={65}
          disableButton={false}
          buttonName={`+ Add Metadata`}
          buttonFunction={handleAdd}
          searchTerm={`name`}
          tableContent={customMetadata}
          tableConfig={tableConfig}
          createPermission={createAllowed}
          disabledButtonTitle={
            defaultLangCheck ? '' : 'Adding Metadata Available on Default Language'
          }
        />
      )}
    </div>
  )
}

export default CustomMetaDataListing
